// extracted by mini-css-extract-plugin
export default {"link":"AuthLink-module__link__KFGts","variant":"AuthLink-module__variant__IJqkj","filled":"AuthLink-module__filled__+9rF1","outlined":"AuthLink-module__outlined__eK9B8"};